/* eslint-disable max-len */
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRoomContext } from '../RoomContext';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import CancelIcon from '@material-ui/icons/Cancel';
import { setWebinarUserToVC } from '../store/actions/webinarActions';

const styles = (theme) =>
	({
		dialogPaper :
	{
		width                          : '30vw',
		[theme.breakpoints.down('lg')] :
		{
			width : '40vw'
		},
		[theme.breakpoints.down('md')] :
		{
			width : '50vw'
		},
		[theme.breakpoints.down('sm')] :
		{
			width : '70vw'
		},
		[theme.breakpoints.down('xs')] :
		{
			width : '90vw'
		}
	},
		dialogActions :
	{
		flexDirection                  : 'row',
		[theme.breakpoints.down('xs')] :
		{
			flexDirection : 'column'
		}
	},

		logo :
	{
		height      : '32px',
		marginLeft  : theme.spacing(1.5),
		marginRight : 'auto'
	},
		divider :
	{
		marginBottom : theme.spacing(3)
	}
	});

const WebinarVcJoinDialog = ({
	// webinarSocket,
	webinarData,
	classes,
	setVc,
	joinOpen
}) =>
{
	const buttonYes = useRef();

	console.log('ijoinOpen', webinarData);

	// const navigate = useHistory();

	const handleEnterKey = (event) =>
	{
		if (event.key === 'Enter')
		{
			buttonYes.current.click();
		}
		else
		if (event.key === 'Escape' || event.key === 'Esc')
		{
			setVc(false);
		}
	};

	const handleStay = () => setVc(false);

	// const userClose=() =>
	// {
	// 	// navigate.push(`/welcome?id=${localStorage.getItem('meetingId')}&sessionId=${localStorage.getItem('sessionId')}&uid=${localStorage.getItem('broadcastUserId')}&name=${localStorage.getItem('broadcastUserName')}`);
	// };

	const handleLeave = () =>
	{
		// webinarSocket.emit('request', { method: 'leaveWebinar', data: {} });
		window.location.href = `${import.meta.env.VITE_config}inconf/${webinarData._id}/false`;
	};

	return (
		<Dialog
			onKeyDown={handleEnterKey}
			open={joinOpen}
			onClose={() => setVc(false)}
			classes={{
				paper : classes.dialogPaper
			}}
		>
			<DialogTitle id='form-dialog-title' dividers>
				<FormattedMessage
					id='room.leavingTheRoom'
					defaultMessage='Host moved to Vc'
				/>
				<span>Host Wants to you Move to vc</span>
			</DialogTitle>
			<DialogContent dividers>
				<span>Do you want to leave the webinar and join in vc</span>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					onClick={handleStay}
					color='primary'
					startIcon={<CancelIcon />}
				>
					<FormattedMessage
						id='label.no'
						defaultMessage='No'
					/>
				</Button>
				<Button
					onClick={handleLeave}
					color='primary'
					startIcon={<MeetingRoomIcon />}
					ref={buttonYes}
				>
					<FormattedMessage
						id='label.yes'
						defaultMessage='Yes'

					/>
				</Button>
			</DialogActions>
		</Dialog>
	);
};

WebinarVcJoinDialog.propTypes =
{
	// webinarSocket : PropTypes.any,
	classes     : PropTypes.object.isRequired,
	setVc       : PropTypes.any,
	joinOpen    : PropTypes.bool.isRequired,
	webinarData : PropTypes.any
};

const mapStateToProps = (state) =>
	({
		// webinarSocket : state.webinar.webinarSocket,
		webinarData : state.webinar.webinarData

	});

const mapDispatchToProps =(dispatch) =>
{
	return {

		setVc : (moveToVc) =>
		{
			dispatch(setWebinarUserToVC(moveToVc));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.webinar.webinarSocket === next.webinar.webinarSocket
			);
		}
	}
)(withStyles(styles)(WebinarVcJoinDialog)));
